/** Member (AppUser) equipment catalogue ↔ UI. */

function toUiKyc(status) {
  if (status === 'verified') return 'Verified';
  if (status === 'rejected') return 'Rejected';
  return 'Pending';
}

function toApiKyc(status) {
  const s = String(status || '').toLowerCase();
  if (s === 'verified') return 'verified';
  if (s === 'rejected') return 'rejected';
  return 'pending';
}

export function userEquipmentFromApi(row) {
  if (!row) return null;
  const typeName =
    row.equipmentTypeName ||
    (typeof row.equipmentType === 'string'
      ? row.equipmentType
      : row.equipmentType?.name || row.equipmentType?.code) ||
    '';
  const user = row.user || null;
  const ownerFromUser = user
    ? user.tradeName ||
      [user.firstName, user.middleName, user.lastName].filter(Boolean).join(' ').trim()
    : '';
  return {
    id: row.id,
    assetId: `UE-${row.id}`,
    userId: row.userId ?? user?.id ?? null,
    ownerName: row.ownerName || ownerFromUser || '',
    ownerPhone: row.ownerPhone || user?.phone || '',
    villageName: row.ownerVillage || user?.village || '',
    equipmentTypeId: row.equipmentTypeId ?? row.equipmentType?.id ?? null,
    equipmentType: typeName,
    equipmentTypeCategory:
      row.equipmentTypeCategory || row.equipmentType?.category || '',
    vehicleClass:
      row.equipmentTypeVehicleClass || row.equipmentType?.vehicleClass || '',
    equipmentDescription: row.description || '',
    manufacturer: row.manufacturer || '',
    model: row.model || '',
    variant: row.variant || '',
    fuel: row.fuel || '',
    color: row.color || '',
    regNo: row.regNo || '',
    chassisNumber: row.chassisNumber || '',
    engineNumber: row.engineNumber || '',
    capacity: row.capacity || '',
    capacityUom: row.capacityUom || '',
    yom: row.yom || '',
    nameAsPerRc: row.nameAsPerRc || '',
    rcValidUntil: row.rcValidUntil || '',
    pucValidUntil: row.pucValidUntil || '',
    insuranceValidUntil: row.insuranceValidUntil || '',
    fitnessValidUntil: row.fitnessValidUntil || '',
    taxValidUntil: row.taxValidUntil || '',
    status: toUiKyc(row.kycStatus),
    kycStatus: row.kycStatus || 'pending',
    rejectionReason: row.rejectionReason || '',
    extractedData:
      row.extractedData && typeof row.extractedData === 'object'
        ? row.extractedData
        : null,
    thumbnailUrl: row.thumbnailUrl || null,
    documents: row.documents || {},
    documentKeys: row.documentKeys || {},
    documentTypes: Array.isArray(row.documentTypes) ? row.documentTypes : [],
    fieldRequirements:
      row.fieldRequirements && typeof row.fieldRequirements === 'object'
        ? row.fieldRequirements
        : {},
    active: row.isActive !== false,
    ownershipStatus: row.ownershipStatus || 'self',
    ownerAadhaarRequired: Boolean(row.ownerAadhaarRequired),
    ownerAadhaarUploaded: Boolean(row.ownerAadhaarUploaded),
    needsOwnerAadhaarUpload: Boolean(row.needsOwnerAadhaarUpload),
    ownerAadhaarRequestNote: row.ownerAadhaarRequestNote || '',
    ownerAadhaarRequestedAt: row.ownerAadhaarRequestedAt || null,
    pendingOwnerAadhaarLast4: row.pendingOwnerAadhaarLast4 || null,
    ownerAadhaarNumberLast4: row.ownerAadhaarNumberLast4 || null,
    ownerAadhaarNumber: row.ownerAadhaarNumber || null,
    registeredByUserId: row.registeredByUserId ?? null,
    legalOwnerUserId: row.legalOwnerUserId ?? null,
    ownershipTransferredAt: row.ownershipTransferredAt || null,
    createdAt: row.createdAt ?? null,
    updatedAt: row.updatedAt ?? null,
  };
}

export { toApiKyc };
